import { Theme, makeStyles } from "@material-ui/core";

export const useHightlightStyles = makeStyles((theme: Theme) => ({
  highlightContainer: {
    padding: "10px",
  },
  highlightItem: {
    backgroundColor: "rgba(255, 236, 214, 0.3)",
    borderRadius: "10px",
    padding: "17px",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontSize: theme.typography.pxToRem(12),
    color: "#45547C",
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      fontFamily: "lato",
    },
  },
  description: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "lato",
    fontWeight: 600,
    color: "#0F172A",
    height: "70px",
    overflow: "hidden",
  },
  date: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#45547C",
    "& .MuiTypography-root": {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      fontFamily: "lato",
    },
  },
  icon: {
    fill: "#45547C",
  },
  textContainer: {
    margin: "7px 5px",
    width: "80%",
  },
}));
